// Format numeru faktury — te same pola, które akceptuje backend (services/invoice_numbering.py).
// Licznikiem jest {n} albo {nn} (z zerem wiodącym); miesiąc w formacie zeruje licznik co miesiąc.
export const NUMBER_FORMAT_FIELD = /\{([^{}]*)\}/g;
export const NUMBER_FORMAT_FIELDS = ['n', 'nn', 'm', 'mm', 'yy', 'yyyy'];
const COUNTER_FIELDS = ['n', 'nn'];

export const NUMBER_FORMAT_HINT =
    '{n} albo {nn} licznik (wymagany, {nn} z zerem wiodącym), {m} / {mm} miesiąc, {yy} / {yyyy} rok.';

export const validateNumberFormat = (format) => {
    const fields = [...format.matchAll(NUMBER_FORMAT_FIELD)].map((match) => match[1]);
    const unknown = fields.filter((field) => !NUMBER_FORMAT_FIELDS.includes(field));
    if (unknown.length > 0) {
        return `Nieznane pola w formacie numeru: ${unknown.join(', ')}`;
    }
    if (!fields.some((field) => COUNTER_FIELDS.includes(field))) {
        return 'Format numeru musi zawierać {n} albo {nn}, inaczej każda faktura dostałaby ten sam numer';
    }
    return '';
};

export const previewNumberFormat = (format, date = new Date()) => {
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const values = {
        n: '1',
        nn: '01',
        m: String(month),
        mm: String(month).padStart(2, '0'),
        yy: String(year % 100).padStart(2, '0'),
        yyyy: String(year),
    };
    return format.replace(NUMBER_FORMAT_FIELD, (_, field) => values[field]);
};
